/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPrison = createReactComponent("outline", "prison", "IconPrison", [["path", { "d": "M18 4v16", "key": "svg-0" }], ["path", { "d": "M14 4v16", "key": "svg-1" }], ["path", { "d": "M6 4v5", "key": "svg-2" }], ["path", { "d": "M6 15v5", "key": "svg-3" }], ["path", { "d": "M10 4v5", "key": "svg-4" }], ["path", { "d": "M11 9h-6v6h6z", "key": "svg-5" }], ["path", { "d": "M10 15v5", "key": "svg-6" }], ["path", { "d": "M8 12h-.01", "key": "svg-7" }]]);

export { IconPrison as default };
//# sourceMappingURL=IconPrison.mjs.map
